<!-- 
Stepper for the status timeline.
-->
<template>
  <div v-if="vertical" style="max-height: 400px; overflow-y: auto">
    <v-stepper :class="{ transparent: transparent }" vertical class="mt-0 elevation-0 status-stepper">
      <template v-for="(item, index) in history">
        <v-stepper-step 
          :key="`step-${index}`" 
          :step="index+1" 
          :complete-icon="getIcon(item)" 
          :class="item.current ? 'current' : ''"
          complete
        >
          <span :class="getClass(item)">
            {{ statusDescriptions[item.status] }}
          </span>
          <small>{{ item.date | squishedDateTime }}</small>
        </v-stepper-step>
        <v-stepper-content :key="`content-${index}`" :step="index+1" />
      </template>
    </v-stepper>
  </div>
  <v-stepper 
    v-else :class="{ transparent: transparent }" :alt-labels="altLabels" :vertical="vertical" 
    class="mt-0 elevation-0 status-stepper"
  >
    <v-stepper-header>
      <template v-for="(item, index) in history">
        <v-stepper-step 
          :key="`step-${index}`" 
          :step="index+1" 
          :complete-icon="getIcon(item)" 
          :class="item.current ? 'current' : ''"
          complete
        >
          <span :class="getClass(item)">
            {{ statusDescriptions[item.status] }}
          </span>
          <span class="caption grey--text text--darken-1">{{ item.date | squishedDateTime }}</span>
        </v-stepper-step>
        <v-divider v-if="index < history.length - 1" :key="`divider-${index}`"/>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  mixins: [filterMixins, lookupMixins],
  props: {
    altLabels: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      required: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    statusDescriptions: {
      type: Object,
      default: () => {}
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getIcon(item) {
      return item.date ? "done" : "hourglass_empty";
    },
    getClass(item) {
      if (item.date) {
        return item.current ? "font-weight-bold" : "";
      } else {
        return "grey--text";
      }
    }
  }
};
</script>

<style lang="scss">
.status-stepper .v-stepper__step {
  .v-stepper__label {
    text-shadow: none !important;
  }
  .v-stepper__step__step {
    &.primary {
      background-color: #bdbdbd !important;
    }
  }
  &.current .v-stepper__step__step.primary {
    background-color: black !important;
  }
}
.transparent {
  background-color: inherit;
}
</style>